import "./App.css";
import Container from "./components/Container";

function App() {
  return (
    <div className="App">
      <header>
        <h1> Counter App </h1>
      </header>
      <Container />
    </div>
  );
}

export default App;
